<ng-template #importTemplate>
  <div class="customer-filter-modal" role="dialog" aria-label="Importar dados">
    <div class="title-filter">
      <strong>{{ titleKey | translate }}</strong>
    </div>

    <div class="a-search-input -light-mode">
      <mat-form-field style="flex: 1">
        <input
          matInput
          [formControl]="searchControl"
          [placeholder]="placeholderText | translate"
        />
        <button
          *ngIf="searchControl.value"
          mat-icon-button
          matSuffix
          type="button"
          (click)="searchControl.reset()"
          aria-label="Clear search"
        >
          <mat-icon fontIcon="bosch-ic-close"></mat-icon>
        </button>
        <button
          *ngIf="!searchControl.value"
          mat-icon-button
          matSuffix
          type="button"
          (click)="onApply()"
          aria-label="Search"
        >
          <mat-icon fontIcon="bosch-ic-search"></mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="customer-list-scroll">
      <mat-checkbox
        *ngFor="let option of filteredOptions; trackBy: trackById"
        [checked]="isSelected(option)"
        (change)="toggleSelection(option)"
      >
        {{ option.label }}
      </mat-checkbox>
    </div>

    <hr />

    <div class="title-filter">
      <strong>{{ "label-upload-file" | translate }}</strong>
    </div>

    <div class="upload-box" (click)="fileInput.click()">
      <mat-icon fontIcon="bosch-ic-export"></mat-icon>
      <input
        type="file"
        #fileInput
        accept=".xlsx, .xls"
        hidden
        (change)="onFileSelected($event)"
      />
    </div>

    <div *ngIf="selectedFileName" class="file-name" style="margin-top: 8px">
      <p style="font-size: 14px">
        {{ "upload-template-modal.uploaded-file" | translate }}:
        {{ selectedFileName }}
      </p>
    </div>

    <div align="end" class="button-row">
      <button mat-button (click)="close()" [disabled]="loading">
        {{ "input-cancel" | translate }}
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="onImport()"
        [disabled]="!selectedFile || !selectedItems.length"
      >
        {{ "upload-template-modal.import" | translate }}
      </button>
    </div>
  </div>
</ng-template>
